import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FiHome, FiFileText, FiBook, FiUsers, FiSettings,
  FiChevronDown, FiChevronRight, FiVideo, FiCalendar,
  FiGrid, FiLogOut, FiUserPlus, FiFile,
  FiMessageCircle, FiEdit, FiAward
} from 'react-icons/fi';

const Sidebar = ({ role }) => {
  const [openCategories, setOpenCategories] = useState({ Dashboard: true });
  const location = useLocation();
  const userName = localStorage.getItem('name') || 'User';

  const toggleCategory = (category) => {
    setOpenCategories((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  const performLogout = () => {
    console.log('Performing logout from sidebar');
    localStorage.removeItem('role');
    localStorage.removeItem('name');
    localStorage.removeItem('email');
    localStorage.removeItem('token');
    window.location.href = '/';
  };

  const routesByRole = {
    admin: [
      {
        category: 'CRM',
        icon: <FiGrid />,
        links: [
          { path: '/', name: 'Dashboard', icon: <FiHome /> },
          { path: '/student-management', name: 'Students CRM', icon: <FiUsers /> },
          { path: '/orders', name: 'Orders', icon: <FiBook /> },
          { path: '/scholarship-tests', name: 'Scholarship Tests', icon: <FiAward /> },
        ],
      },
      {
        category: 'Test Library',
        icon: <FiBook />,
        links: [
          { path: '/folders', name: 'Folders', icon: <FiFileText /> },
          { path: '/student-test-records/', name: 'Test Records', icon: <FiFileText /> },
        ],
      },
      {
        category: 'Content',
        icon: <FiVideo />,
        links: [
          { path: '/live-classes', name: 'Live Classes', icon: <FiCalendar /> },
          { path: '/test-series', name: 'Test Series', icon: <FiFileText /> },
          { path: '/recorded-course', name: 'Recorded Course', icon: <FiVideo /> },
        ],
      },
      {
        category: 'Community',
        icon: <FiUsers />,
        links: [
          { path: '/community-documents', name: 'Documents', icon: <FiFile /> },
          { path: '/discuss-ask', name: 'Discuss & Ask', icon: <FiMessageCircle /> },
          { path: '/test-of-the-day', name: 'Test of the Day', icon: <FiEdit /> },
        ],
      },
      {
        category: 'Settings',
        icon: <FiSettings />,
        links: [
          { path: '/app-home-management', name: 'Home Management', icon: <FiHome /> },
          { path: '/student', name: 'Student', icon: <FiUsers /> },
          { path: '/users', name: 'Users', icon: <FiUserPlus /> },
        ],
      },
    ],
    teacher: [
      {
        category: 'Test Library',
        icon: <FiBook />,
        links: [
          { path: '/folders', name: 'Folders', icon: <FiFileText /> },
          { path: '/student-test-records', name: 'Student Records', icon: <FiFileText /> },
        ],
      },
      {
        category: 'Live Classes',
        icon: <FiVideo />,
        links: [
          { path: '/live-classes', name: 'Live Classes', icon: <FiCalendar /> },
        ],
      },
    ],
    counsellor: [
      {
        category: 'CRM',
        icon: <FiGrid />,
        links: [
          { path: '/', name: 'Dashboard', icon: <FiHome /> },
          { path: '/student-management', name: 'Students CRM', icon: <FiUsers /> },
          { path: '/orders', name: 'Orders', icon: <FiBook /> },
          { path: '/scholarship-tests', name: 'Scholarship Tests', icon: <FiAward /> },
        ],
      },
      {
        category: 'Content',
        icon: <FiVideo />,
        links: [
          { path: '/live-classes', name: 'Live Classes', icon: <FiCalendar /> },
          { path: '/test-series', name: 'Test Series', icon: <FiFileText /> },
          { path: '/recorded-course', name: 'Recorded Course', icon: <FiVideo /> },
        ],
      },
      {
        category: 'Test Library',
        icon: <FiBook />,
        links: [
          { path: '/folders', name: 'Folders', icon: <FiFileText /> },
          { path: '/student-test-records/', name: 'Test Records', icon: <FiFileText /> },
          { path: '/test-of-the-day', name: 'Test of the Day', icon: <FiEdit /> },
        ],
      },
      {
        category: 'Student',
        icon: <FiUsers />,
        links: [
          { path: '/student', name: 'Student', icon: <FiUsers /> },
        ],
      },
    ],
  };

  const routes = routesByRole[role] || routesByRole.admin;
  const isActive = (path) => location.pathname === path;

  return (
    <div className="w-72 fixed h-full bg-gradient-to-b from-blue-600 to-blue-400 text-white shadow-xl z-50">
      <div className="h-full flex flex-col">
        <div className="py-2 px-3">
          <div className="flex items-center">
            <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center border border-blue-300">
              <span className="text-white font-bold text-lg">SSC</span>
            </div>
            <div className="ml-2">
              <h2 className="text-base font-bold text-white m-0">SAINIK SCHOOL CADET</h2>
            </div>
          </div>
        </div>

        <div className="border-b border-blue-500"></div>

        <div className="px-6 py-4 border-b border-blue-500">
          <h3 className="text-white text-sm font-medium">{userName}</h3>
          <p className="text-blue-200 text-xs">
            {role === 'admin' ? 'Administrator' : role === 'teacher' ? 'Teacher' : 'Counselor'}
          </p>
        </div>

        <div className="flex-grow overflow-auto py-4 scrollbar-thin scrollbar-thumb-blue-300 scrollbar-track-transparent">
          {routes.map((category) => (
            <div key={category.category} className="mb-2 px-3">
              <div
                className="flex items-center justify-between p-3 text-white hover:bg-blue-700 transition-all duration-200 rounded-lg cursor-pointer"
                onClick={() => toggleCategory(category.category)}
              >
                <div className="flex items-center">
                  <span className="text-lg mr-3">{category.icon}</span>
                  <span className="text-sm font-medium">{category.category}</span>
                </div>
                <span className="text-sm text-blue-100">
                  {openCategories[category.category] ? <FiChevronDown /> : <FiChevronRight />}
                </span>
              </div>
              {openCategories[category.category] && (
                <div className="ml-7 mt-2 space-y-1">
                  {category.links.map((route) => (
                    <Link
                      key={route.path}
                      to={route.path}
                      className={`flex items-center py-2 px-3 text-sm rounded-lg transition-all duration-200 ${
                        isActive(route.path)
                          ? 'bg-blue-700 text-white font-medium shadow-md'
                          : 'text-blue-100 hover:bg-blue-700 hover:text-white'
                      }`}
                    >
                      <div className={`mr-3 text-base ${isActive(route.path) ? 'text-white' : 'text-blue-200'}`}>
                        {route.icon}
                      </div>
                      <span>{route.name}</span>
                      {isActive(route.path) && (
                        <div className="w-1.5 h-1.5 rounded-full bg-white ml-auto"></div>
                      )}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-auto px-6 py-5 border-t border-blue-500">
          <button
            type="button"
            onClick={performLogout}
            className="flex items-center justify-center w-full py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-all duration-200 cursor-pointer"
          >
            <FiLogOut className="mr-3" />
            <span className="font-medium">Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
